import { render, staticRenderFns } from "./NieuwsmakerVoteSlide.vue?vue&type=template&id=e4684376"
import script from "./NieuwsmakerVoteSlide.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerVoteSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports